import { ChevronDownIcon } from "lucide-react";

export const DecisionLogsHeader = ({
    receivedLogsIsOpened,
    setReceivedLogsIsOpened,
}) => {
    return (
        <div className={`
            flex items-start justify-between gap-3 ${receivedLogsIsOpened ? "pb-3 border-b border-border" : "pb-0"}
         `}>
             <div>
                 <p className="text-[10px] uppercase tracking-[0.14em] text-gray-600">
                     Decision logs
                 </p>
                 <h3 className="text-sm font-semibold text-primary">
                     Recommendation history
                 </h3>
             </div>
             <button
                 className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border shadow-xs hover:bg-gray-50 dark:bg-transparent dark:border-input dark:hover:bg-input/50 py-2 has-[>svg]:px-3 h-8 rounded-md bg-white px-2.5"
                 onClick={() => setReceivedLogsIsOpened(!receivedLogsIsOpened)}
             >
                 <ChevronDownIcon className={`size-4 transition-transform ${receivedLogsIsOpened ? "rotate-180" : ""}`} />
             </button>
        </div>
    )
};